import Modal from 'react-modal';
import React, { useEffect } from 'react';

interface Props {
    open: boolean;
    handleClose: () => void;
    title: string;
    subtitle: string;
    twoButtons: boolean;
    buttonOneText: string;
    buttonOneAction: () => void;
    buttonTwoText: string;
    buttonTwoAction: () => void;
    children: React.ReactNode;
}

function ModalInput(props: Props) {
    useEffect(() => {
        // Set the app element for the modal
        Modal.setAppElement('#root');
    }, []);

    return (
        <Modal
            className="precheck-submitted-modal rounded bg-white border d-flex flex-column text-center"
            isOpen={props.open}
            onRequestClose={() => props.handleClose()}
            ariaHideApp={false}>
            <div className="rounded-top w-100 modal-header"></div>
            <span className="form-title">{props.title}</span>
            <div className="form-subtitle mx-2">{props.subtitle}</div>
            <div className="form-subtitle mx-2 flex justify-content-center">{props.children}</div>
            <div className="d-flex justify-content-center w-100">
                <button
                    className="btn bg-dark text-white my-4 mx-2 px-4"
                    onClick={() => {props.buttonOneAction()}}>
                    {props.buttonOneText}
                </button>
                {props.twoButtons && (
                    <button
                        className="btn bg-dark text-white my-4 mx-2 px-4"
                        onClick={() => props.buttonTwoAction()}>
                        {props.buttonTwoText}
                    </button>
                )}
            </div>
        </Modal>
    );
}

export default ModalInput;
